/*!
 * KoliBri - The accessible HTML-Standard
 */
let KolAbbrTag = 'kol-abbr';
let KolAccordionTag = 'kol-accordion';
let KolAlertTag = 'kol-alert';
let KolAlertWcTag = 'kol-alert-wc';
let KolAvatarTag = 'kol-avatar';
let KolAvatarWcTag = 'kol-avatar-wc';
let KolBadgeTag = 'kol-badge';
let KolBreadcrumbTag = 'kol-breadcrumb';
let KolButtonLinkTag = 'kol-button-link';
let KolButtonTag = 'kol-button';
let KolButtonWcTag = 'kol-button-wc';
let KolCardTag = 'kol-card';
let KolCardWcTag = 'kol-card-wc';
let KolComboboxTag = 'kol-combobox';
let KolDetailsTag = 'kol-details';
let KolDialogTag = 'kol-dialog';
let KolDialogWcTag = 'kol-dialog-wc';
let KolDrawerTag = 'kol-drawer';
let KolFormTag = 'kol-form';
let KolHeadingTag = 'kol-heading';
let KolIconTag = 'kol-icon';
let KolImageTag = 'kol-image';
let KolInputCheckboxTag = 'kol-input-checkbox';
let KolInputColorTag = 'kol-input-color';
let KolInputDateTag = 'kol-input-date';
let KolInputEmailTag = 'kol-input-email';
let KolInputFileTag = 'kol-input-file';
let KolInputNumberTag = 'kol-input-number';
let KolInputPasswordTag = 'kol-input-password';
let KolInputRadioTag = 'kol-input-radio';
let KolInputRangeTag = 'kol-input-range';
let KolInputTag = 'kol-input';
let KolInputTextTag = 'kol-input-text';
let KolKolibriTag = 'kol-kolibri';
let KolLinkButtonTag = 'kol-link-button';
let KolLinkTag = 'kol-link';
let KolLinkWcTag = 'kol-link-wc';
let KolMeterTag = 'kol-meter';
let KolModalTag = 'kol-modal';
let KolNavTag = 'kol-nav';
let KolPaginationTag = 'kol-pagination';
let KolPaginationWcTag = 'kol-pagination-wc';
let KolPopoverButtonTag = 'kol-popover-button';
let KolPopoverButtonWcTag = 'kol-popover-button-wc';
let KolProgressTag = 'kol-progress';
let KolQuoteTag = 'kol-quote';
let KolSelectTag = 'kol-select';
let KolSelectWcTag = 'kol-select-wc';
let KolSingleSelectTag = 'kol-single-select';
let KolSkipNavTag = 'kol-skip-nav';
let KolSpinTag = 'kol-spin';
let KolSplitButtonTag = 'kol-split-button';
let KolTableSettingsWcTag = 'kol-table-settings-wc';
let KolTableStatefulTag = 'kol-table-stateful';
let KolTableStatelessTag = 'kol-table-stateless';
let KolTableStatelessWcTag = 'kol-table-stateless-wc';
let KolTabsTag = 'kol-tabs';
let KolTextareaTag = 'kol-textarea';
let KolToastContainerTag = 'kol-toast-container';
let KolTooltipWcTag = 'kol-tooltip-wc';
let KolTreeItemTag = 'kol-tree-item';
let KolTreeItemWcTag = 'kol-tree-item-wc';
let KolTreeTag = 'kol-tree';
let KolTreeWcTag = 'kol-tree-wc';
let KolVersionTag = 'kol-version';
const setCustomTagNames = (transformTagName) => {
    KolAbbrTag = transformTagName(KolAbbrTag);
    KolAccordionTag = transformTagName(KolAccordionTag);
    KolAlertTag = transformTagName(KolAlertTag);
    KolAlertWcTag = transformTagName(KolAlertWcTag);
    KolAvatarTag = transformTagName(KolAvatarTag);
    KolAvatarWcTag = transformTagName(KolAvatarWcTag);
    KolBadgeTag = transformTagName(KolBadgeTag);
    KolBreadcrumbTag = transformTagName(KolBreadcrumbTag);
    KolButtonLinkTag = transformTagName(KolButtonLinkTag);
    KolButtonTag = transformTagName(KolButtonTag);
    KolButtonWcTag = transformTagName(KolButtonWcTag);
    KolCardTag = transformTagName(KolCardTag);
    KolCardWcTag = transformTagName(KolCardWcTag);
    KolComboboxTag = transformTagName(KolComboboxTag);
    KolDetailsTag = transformTagName(KolDetailsTag);
    KolDialogTag = transformTagName(KolDialogTag);
    KolDialogWcTag = transformTagName(KolDialogWcTag);
    KolDrawerTag = transformTagName(KolDrawerTag);
    KolFormTag = transformTagName(KolFormTag);
    KolHeadingTag = transformTagName(KolHeadingTag);
    KolIconTag = transformTagName(KolIconTag);
    KolImageTag = transformTagName(KolImageTag);
    KolInputCheckboxTag = transformTagName(KolInputCheckboxTag);
    KolInputColorTag = transformTagName(KolInputColorTag);
    KolInputDateTag = transformTagName(KolInputDateTag);
    KolInputEmailTag = transformTagName(KolInputEmailTag);
    KolInputFileTag = transformTagName(KolInputFileTag);
    KolInputNumberTag = transformTagName(KolInputNumberTag);
    KolInputPasswordTag = transformTagName(KolInputPasswordTag);
    KolInputRadioTag = transformTagName(KolInputRadioTag);
    KolInputRangeTag = transformTagName(KolInputRangeTag);
    KolInputTag = transformTagName(KolInputTag);
    KolInputTextTag = transformTagName(KolInputTextTag);
    KolKolibriTag = transformTagName(KolKolibriTag);
    KolLinkButtonTag = transformTagName(KolLinkButtonTag);
    KolLinkTag = transformTagName(KolLinkTag);
    KolLinkWcTag = transformTagName(KolLinkWcTag);
    KolMeterTag = transformTagName(KolMeterTag);
    KolModalTag = transformTagName(KolModalTag);
    KolNavTag = transformTagName(KolNavTag);
    KolPaginationTag = transformTagName(KolPaginationTag);
    KolPaginationWcTag = transformTagName(KolPaginationWcTag);
    KolPopoverButtonTag = transformTagName(KolPopoverButtonTag);
    KolPopoverButtonWcTag = transformTagName(KolPopoverButtonWcTag);
    KolProgressTag = transformTagName(KolProgressTag);
    KolQuoteTag = transformTagName(KolQuoteTag);
    KolSelectTag = transformTagName(KolSelectTag);
    KolSelectWcTag = transformTagName(KolSelectWcTag);
    KolSingleSelectTag = transformTagName(KolSingleSelectTag);
    KolSkipNavTag = transformTagName(KolSkipNavTag);
    KolSpinTag = transformTagName(KolSpinTag);
    KolSplitButtonTag = transformTagName(KolSplitButtonTag);
    KolTableSettingsWcTag = transformTagName(KolTableSettingsWcTag);
    KolTableStatefulTag = transformTagName(KolTableStatefulTag);
    KolTableStatelessTag = transformTagName(KolTableStatelessTag);
    KolTableStatelessWcTag = transformTagName(KolTableStatelessWcTag);
    KolTabsTag = transformTagName(KolTabsTag);
    KolTextareaTag = transformTagName(KolTextareaTag);
    KolToastContainerTag = transformTagName(KolToastContainerTag);
    transformTagName(KolTooltipWcTag);
    KolTooltipWcTag = transformTagName(KolTooltipWcTag);
    KolTreeItemTag = transformTagName(KolTreeItemTag);
    KolTreeItemWcTag = transformTagName(KolTreeItemWcTag);
    KolTreeTag = transformTagName(KolTreeTag);
    KolTreeWcTag = transformTagName(KolTreeWcTag);
    KolVersionTag = transformTagName(KolVersionTag);
};

export { KolToastContainerTag as K, KolAlertWcTag as a, KolButtonWcTag as b, KolLinkWcTag as c, KolCardWcTag as d, KolDialogWcTag as e, KolPopoverButtonWcTag as f, KolFormTag as g, KolPaginationWcTag as h, KolLinkTag as i, KolSelectWcTag as j, KolTableStatelessWcTag as k, KolButtonTag as l, KolTreeWcTag as m, KolTreeItemWcTag as n, KolBadgeTag as o, KolInputCheckboxTag as p, KolInputNumberTag as q, KolTableSettingsWcTag as r, setCustomTagNames as s, KolTreeTag as t, KolTreeItemTag as u };
//# sourceMappingURL=component-names-DwvrfFak.js.map

//# sourceMappingURL=component-names-DwvrfFak.js.map